import { useMediaQuery, useTheme } from "@mui/material";

export function useBreakpoint() {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("md"));
	const isTablet = useMediaQuery(
		`(min-width:${theme.breakpoints.values.md}px) and (max-width:${theme.breakpoints.values.lg - 0.05}px) and (pointer: coarse)`
	);
	return { isMobile, isTablet };
}
